module.exports = __webpack_public_path__ + "static/facebook-template-9ba6bdf7d04fac786d0e5b8d2fa082aa.png";